// WithoutNav.js (Stand-alone Functional Component)
import React from 'react';
import { Outlet } from 'react-router-dom';

export default () => <Outlet />